import React from 'react';
import { Flex, Heading } from 'rebass';
import Frame from 'components/Frame';
import SortingDropdown from 'components/SortingDropdown';
import PendingCandidatesList from 'modules/Candidates/components/PendingCandidatesList';
import usePendingCandidatesList from 'modules/Candidates/hooks/usePendingCandidatesList';
import MessagePage from './MessagePage';

const ReviewPendingCandidates: React.FC = (): JSX.Element => {
  const { pendingCandidates } = usePendingCandidatesList();

  return (
    <>
      <Flex>
        <Frame>
          {pendingCandidates.length ? (
            <Flex width="100%" flexDirection="column">
              <Flex width="100%" flexDirection="column" pt={7} pb={1}>
                <Heading as="h2" fontSize="36px" fontWeight={6} mb={6}>
                  New Candidates
                </Heading>
                <Flex width="100%" justifyContent="flex-end" mb={6}>
                  <SortingDropdown text="Sort by Newest" />
                </Flex>
              </Flex>
              <PendingCandidatesList candidatesList={pendingCandidates} />
            </Flex>
          ) : (
            <MessagePage text="You don`t have new Candidates" />
          )}
        </Frame>
      </Flex>
    </>
  );
};

export default ReviewPendingCandidates;
